/**
 * Laden, leer, kaputt — die drei Zustaende, die jede Liste hat.
 *
 * Sie stehen zusammen in einer Datei, weil sie zusammen gedacht werden muessen:
 * Eine leere Flaeche ist von einem Fehler nicht zu unterscheiden, und genau
 * dieser Zweifel kostet dann eine Rueckfrage. Deshalb sagt jeder Zustand,
 * welcher er ist.
 */

import { ReactNode } from 'react';
import { AlertCircle, Inbox, Loader2 } from 'lucide-react';

import { Button } from './Button';

export function Laden({ text = 'Wird geladen …' }: { text?: string }) {
  return (
    <div className="flex items-center justify-center gap-2 py-16 text-sm text-slate-500">
      <Loader2 size={16} className="animate-spin" />
      {text}
    </div>
  );
}

export function Leer({
  titel,
  hinweis,
  children,
}: {
  titel: string;
  hinweis?: string;
  children?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-white px-6 py-14 text-center">
      <Inbox size={22} className="text-slate-300" />
      <p className="mt-3 text-sm font-medium text-slate-700">{titel}</p>
      {hinweis && <p className="mt-1 max-w-md text-sm text-slate-500">{hinweis}</p>}
      {children && <div className="mt-4">{children}</div>}
    </div>
  );
}

export function Fehler({
  text,
  onErneut,
}: {
  text: string;
  onErneut?: () => void;
}) {
  return (
    <div className="flex items-start gap-3 rounded-xl border border-danger-200 bg-danger-50 px-5 py-4">
      <AlertCircle size={18} className="mt-0.5 shrink-0 text-danger-600" />
      <div className="flex-1">
        <p className="text-sm font-medium text-danger-700">Das hat nicht geklappt.</p>
        <p className="mt-0.5 text-sm text-danger-700/80">{text}</p>
      </div>
      {onErneut && (
        <Button variant="outline" size="sm" onClick={onErneut}>
          Erneut versuchen
        </Button>
      )}
    </div>
  );
}

/**
 * Ein Hinweisband — fuer Dinge, die kein Fehler sind, aber auffallen muessen:
 * der Mock-Modus, der Trockenmodus, „nur Admin".
 */
export function Band({
  farbe = 'neutral',
  children,
}: {
  farbe?: 'neutral' | 'warnung';
  children: ReactNode;
}) {
  return (
    <div
      className={
        farbe === 'warnung'
          ? 'rounded-xl border border-warning-200 bg-warning-50 px-4 py-2.5 text-sm text-warning-700'
          : 'rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm text-slate-600'
      }
    >
      {children}
    </div>
  );
}
